document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-form-buttons .shopify-payment-button__button').forEach((button) => {
    button.textContent = 'Order Now';
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.toggle-btn');
    if (!button) return;

    event.preventDefault();
    const content = button.parentElement?.querySelector('.more-text');
    if (!content) return;

    const isOpen = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isOpen));
    button.textContent = isOpen ? 'Read More' : 'Read Less';
    content.hidden = isOpen;
    content.style.display = isOpen ? 'none' : 'block';
  });
});
